export default "__VITE_ASSET__DIgaZax0__"